export default __webpack_public_path__ + "static/media/3334 cutlery side.9f8a9e92.png";